import { render, staticRenderFns } from "./ArticleIcons.vue?vue&type=template&id=2be1d15c&scoped=true"
import script from "./ArticleIcons.vue?vue&type=script&lang=js"
export * from "./ArticleIcons.vue?vue&type=script&lang=js"
import style0 from "./ArticleIcons.vue?vue&type=style&index=0&id=2be1d15c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1d15c",
  null
  
)

export default component.exports